const LANG = {
  "APP_SUBTITLE": "shown by $[metric] for $[demographic] by $[region]",
  "APP_SUBTITLE_GAP": "shown by gap in $[metric] for $[demographic] students by $[region]",
  "APP_TITLE": "$[opportunityType] in $[filterLocation], 2022-2025",
  "APP_TITLE_GAP": "Differences in $[opportunityType] in $[filterLocation], 2022-2025",
  "AXIS_AVG_GAP_HIGH": "+$[value] grade level\ndifference",
  "AXIS_AVG_GAP_HIGH_SINGLE": "$[value] grade level\ndifference",
  "AXIS_AVG_GAP_LOW": "-$[value] grade level\ndifference",
  "AXIS_AVG_GAP_LOW_SINGLE": "$[value] grade level\ndifference",
  "AXIS_AVG_GAP_MID": "no\ngap",
  "AXIS_AVG_HIGH": "$[value] grades\nabove",
  "AXIS_AVG_HIGH_SINGLE": "$[value] grade\nabove",
  "AXIS_AVG_LOW": "$[value] grades\nbelow",
  "AXIS_AVG_LOW_SINGLE": "$[value] grade\nbelow",
  "AXIS_AVG_MID": "national\naverage",
  "AXIS_COH_GAP_HIGH": "$[value] grade levels\nper year difference",
  "AXIS_COH_GAP_LOW": "-$[value] grade levels\nper year difference",
  "AXIS_COH_GAP_MID": "no\ndifference",
  "AXIS_COH_HIGH": "improved $[value]\ngrade levels / year",
  "AXIS_COH_HIGH_SINGLE": "improved $[value]\ngrade level / year",
  "AXIS_COH_LOW": "declined $[value]\ngrade levels / year",
  "AXIS_COH_LOW_SINGLE": "dropped $[value]\ngrade level",
  "AXIS_COH_MID": "no\nchange",
  "AXIS_IMP_GAP_HIGH": "$[value] grade levels\nper year difference",
  "AXIS_IMP_GAP_LOW": "-$[value] grade levels\nper year difference",
  "AXIS_IMP_GAP_MID": "no\ndifference",
  "AXIS_IMP_HIGH": "improved $[value]\ngrade levels / year",
  "AXIS_IMP_HIGH_SINGLE": "improved $[value]\ngrade levels / year",
  "AXIS_IMP_LOW": "declined $[value]\ngrade levels / year",
  "AXIS_IMP_LOW_SINGLE": "dropped $[value]\ngrade level",
  "AXIS_IMP_MID": "no\nchange",
  "AXIS_FRL_HIGH": "← more poverty",
  "AXIS_FRL_HIGH_SINGLE": "← more poverty",
  "AXIS_FRL_MID": "less poverty →",
  "AXIS_GRD_GAP_HIGH": "$[value] grade levels\nper year difference",
  "AXIS_GRD_GAP_LOW": "-$[value] grade levels\nper year difference",
  "AXIS_GRD_GAP_MID": "no\ndifference",
  "AXIS_GRD_HIGH": "learned\n$[value] more",
  "AXIS_GRD_HIGH_SINGLE": "learned\n$[value] more",
  "AXIS_GRD_LOW": "learned\n$[value] less",
  "AXIS_GRD_LOW_SINGLE": "learned\n$[value] less",
  "AXIS_GRD_MID_SINGLE": "learned 1 grade\nlevel per year",
  "AXIS_MIN_GAP_HIGH": "$[value]",
  "AXIS_MIN_GAP_LOW": "$[value]",
  "AXIS_MIN_GAP_MID": "no gap",
  "AXIS_NAME_FRL_PCT": "% of students qualifying for free or reduced lunch program",
  "AXIS_NAME_SES": "",
  "AXIS_PREV_HIGH_SINGLE": "",
  "AXIS_PREV_MID": "",
  "AXIS_PREV_ZERO": "",
  "AXIS_SEG_GAP_HIGH": "+$[value]",
  "AXIS_SEG_GAP_LOW": "-$[value]",
  "AXIS_SEG_GAP_MID": "no gap",
  "AXIS_SEG_HIGH": "more",
  "AXIS_SEG_LOW": "less",
  "AXIS_SEG_MID": "no\ngap",
  "AXIS_SES_GAP_HIGH": "larger gap →",
  "AXIS_SES_GAP_LOW": "← larger gap",
  "AXIS_SES_GAP_MID": "no\ngap",
  "AXIS_SES_GAP_ZERO": "no gap in\nsocioeconomic status",
  "AXIS_SES_HIGH": "richer →",
  "AXIS_SES_HIGH_SINGLE": "richer →",
  "AXIS_SES_LOW": "← poorer",
  "AXIS_SES_LOW_SINGLE": "← poorer",
  "AXIS_SES_MID": "national\naverage",
  "BUTTON_HIDE_CHART": "Hide gap chart",
  "BUTTON_SHOW_CHART": "Show gap vs. other metrics",
  "COMPARE_HINT_AVG": "grade levels relative to national average",
  "COMPARE_HINT_COH": "average change in test scores each year",
  "COMPARE_HINT_IMP": "average change in learning rates each year",
  "COMPARE_HINT_FRL": "",
  "COMPARE_HINT_GRD": "% learned each grade, relative to national average",
  "COMPARE_HINT_SES": "average SES in the community, not specific to any group",
  "COMPARE_HINT_SES_ALL": "Average SES among all families in the community",
  "COMPARE_HINT_SES_GAP": "Average $[gap] SES in the community",
  "COMPARE_HINT_SES_GAP_NA": "Average $[gap] in SES not available",
  "COMPARE_HINT_SES_SUBGROUP": "Average SES among all $[subgroup] families in the community",
  "COMPARE_HINT_SES_NA": "Average SES not available for $[subgroup] families",
  "COMPARE_SUBTITLE": "to $[location]",
  "COMPARE_TITLE": "Compare $[region]",
  "DATA_UNAVAILABLE": "No data available",
  "DIFF_HIGH": "higher than",
  "DIFF_LOW": "lower than",
  "DIFF_MID": "roughly equal to",
  "DIFF_VERY_HIGH": "much higher than",
  "DIFF_VERY_LOW": "much lower than",
  "EMBED_CHART_INPUT_LABEL": "Chart Embed Code",
  "EMBED_CHART_INSTRUCTIONS": "Use the code below to embed the chart on your website. The chart will match your current data selections.",
  "EMBED_CHART_PREVIEW": "View Chart Preview",
  "EMBED_COPY_LABEL": "Copy embed code",
  "EMBED_DIALOG_TITLE": "Embed a Map or Chart",
  "EMBED_MAP_INPUT_LABEL": "Map Embed Code",
  "EMBED_MAP_INSTRUCTIONS": "Use the code below to embed the map on your website. The map will match your current map view and selections in the explorer.",
  "EMBED_MAP_PREVIEW": "View Map Preview",
  "EMBED_MAP_SUBTITLE": "shown by $[metric] for $[demographic] in grades 3 - 8 from 2022 - 2025",
  "EMBED_MAP_TITLE": "$[concept] in U.S. $[region]",
  "EMBED_SECONDARY_INSTRUCTIONS": "The current gap view has two charts, use the code below to embed the secondary chart on your website.",
  "FILTER_HINT_AVG": "measured in grade levels relative to national average",
  "FILTER_HINT_COH": "measured by average change in cohort test scores each year",
  "FILTER_HINT_IMP": "measured by average change in learning rates each year",
  "FILTER_HINT_FRL": "show schools within this range of % qualifying for free or reduced lunch program",
  "FILTER_HINT_GRD": "measured by average test score improvement each grade as student progresses",
  "FILTER_HINT_LOCATION": "Show $[regions] within the below location",
  "FILTER_HINT_SES": "measured in standard deviations from average",
  "FILTER_HINT_SIZE": "Limit the number of $[regions] shown by number of students",
  "FILTER_LABEL_AVG": "Average Test Score Range",
  "FILTER_LABEL_AVG_DESC": "",
  "FILTER_LABEL_COH": "Trend in Test Score Range",
  "FILTER_LABEL_COH_DESC": "",
  "FILTER_LABEL_IMP": "Trend in Learning Rates Range",
  "FILTER_LABEL_IMP_DESC": "",
  "FILTER_LABEL_FRL": "Free/Reduced Lunch Program Range",
  "FILTER_LABEL_GRD": "Learning Rate Range",
  "FILTER_LABEL_GRD_DESC": "",
  "FILTER_LABEL_LOCATION": "Show $[region] within",
  "FILTER_LABEL_SCHOOL_TYPE": "Show School Types",
  "FILTER_LABEL_SES": "Socioeconomic Status Range",
  "FILTER_LABEL_SES_DESC": "",
  "FILTER_LABEL_SIZE": "Show Largest",
  "FILTER_LABEL_SIZE_DESC": "",
  "FILTER_LARGEST": "Filter by size",
  "FILTER_LARGEST_SELECTION": "Largest $[num] $[region]",
  "FILTER_PLACEHOLDER_COUNTIES": "Search for a state",
  "FILTER_PLACEHOLDER_DISTRICTS": "Search for a state",
  "FILTER_PLACEHOLDER_SCHOOLS": "Search for a state or district",
  "FILTER_PLACEHOLDER_STATES": "Unavailable",
  "FILTER_PREFIX_COUNTIES": "Filter by county",
  "FILTER_PREFIX_DISTRICTS": "Filter by district",
  "FILTER_PREFIX_STATES": "Filter by state",
  "FILTER_RESET": "Reset Data Filters",
  "FLAG_GIFTED": "This school has a high percentage of gifted students; keep in mind when interpreting test scores. See <a target=\"_blank\" href=\"/help-faq/#data-adjustments\">FAQ</a> for information.",
  "FLAG_LEP": "This school serves primarily students with limited English proficiency (LEP); keep in mind when interpreting test scores. See <a target=\"_blank\" href=\"/help-faq/#data-adjustments\">FAQ</a> for information.",
  "FLAG_SPEDIDEA": "This school serves primarily special education students; keep in mind when interpreting test scores. See <a target=\"_blank\" href=\"/help-faq/#data-adjustments\">FAQ</a> for information.",
  "FLAG_YEARS": "The estimates reported are based on all available data for this $[region] from 2022-2025. This $[region] is missing data for $[years].",
  "FLAG_LABEL_AGE": "School Age Group",
  "FLAG_LABEL_ALL": "All schools",
  "FLAG_LABEL_AREA": "Area Classification",
  "FLAG_LABEL_BIE": "BIE",
  "FLAG_LABEL_BIE_GROUP": "Bureau of Indian Education",
  "FLAG_LABEL_C": "Combined",
  "FLAG_LABEL_CH": "Charter",
  "FLAG_LABEL_E": "Elementary",
  "FLAG_LABEL_M": "Middle",
  "FLAG_LABEL_MG": "Magnet",
  "FLAG_LABEL_R": "Rural",
  "FLAG_LABEL_RG": "Regular",
  "FLAG_LABEL_S": "Suburban",
  "FLAG_LABEL_SCHOOL": "School Type",
  "FLAG_LABEL_T": "Town",
  "FLAG_LABEL_U": "Urban",
  "FOOTER_COPYRIGHT": "Copyright $[year]",
  "FOOTER_EMBED_LINK": "Embed the map or chart",
  "FOOTER_EXPORT_LABEL": "Export:",
  "FOOTER_EXPORT_PDF": "PDF",
  "FOOTER_EXPORT_PPT": "Powerpoint",
  "FOOTER_SHARE_FACEBOOK": "Share on Facebook",
  "FOOTER_SHARE_LABEL": "Share:",
  "FOOTER_SHARE_LINK": "Share Link",
  "FOOTER_SHARE_TWITTER": "Share on Twitter",
  "HEADER_TITLE_LARGEST": "in the largest $[num] $[region]",
  "HEADER_TITLE_PREFIX": "in $[0]",
  "HELP_AVG": "How are average test scores calculated?",
  "HELP_AVG_A": "The average test score is based on the average of standardized math and Reading Language Arts (RLA) tests taken by public-school students in grades 3 through 8 between 2022 and 2025. See the <a href=\"/help-faq/#how-measures-computed\" target=\"_blank\">FAQ</a> for more detail.",
  "HELP_AVG_CONCEPT": "Why do average test scores show educational opportunities in and out of school?",
  "HELP_AVG_CONCEPT_A": "Average student test scores are influenced by opportunities to learn starting from birth, and therefore are not a good way to assess how much children learn in schools. They are, however, a good way to assess the average set of educational opportunities available to children in a community. Where average scores are low, students have fewer opportunities to learn. Schools are better evaluated using learning rates, which measure how much students’ scores improve while they are in school.",
  "HELP_BUTTON": "Help",
  "HELP_CHART": "What does the chart show?",
  "HELP_CHART_DOTS": "This is a chart of $[region] in the U.S. Each circle represents a $[regionSingle], and the circle’s size is proportionate to the number of students (e.g. a larger circle is a $[regionSingle] with more students). On the vertical (Y) axis is the range of $[metric] for students on a scale. The horizontal (X) axis shows the $[region] socioeconomic status (SES), which is a broad measure of the economic and social resources available in a community.",
  "HELP_CHART_PRIMARY": "The primary chart shows a comparison of $[demographic1] and $[demographic2] students’ $[metric]. Each circle represents a $[region] in $[state]. The circle’s size shows the number of students. The vertical (Y) axis shows $[metricRange] for $[demographic2] students, on a scale $[metricDescription]. The horizontal (X) axis shows the same for $[demographic1] students.",
  "HELP_CHART_SECONDARY": "The chart on the right shows the $[gap] in $[metric] on the vertical (Y) axis. The higher up the axis, the larger the gap. The horizontal (X) axis shows the gap in $[secondary] between these two groups. The farther to the right, the larger the gap favors $[demographic1] families. Each circle represents a $[region] in $[state]. The circle’s size shows the number of students.",
  "HELP_CHART_X_FRL": "The horizontal (X) axis shows the percentage of students at the school who are eligible for the Federal Free & Reduced Price Lunch Program.",
  "HELP_CHART_X_SES": "The horizontal (X) axis shows the $[region]’s socioeconomic status (SES), which is a broad measure of the economic and social resources available in a community.",
  "HELP_CHART_Y": "This chart of $[region] in $[state] shows, on the vertical (Y) axis, $[metric] for $[demographic] on a scale $[metricDescription].",
  "HELP_COH": "How are trends in test scores calculated?",
  "HELP_COH_A": "The trend in test scores is based on changes in average test scores from each year to the next in the same grade (e.g. changes from 2015 3rd-grade scores to 2016 3rd-grade scores). The test-score trends are calculated using standardized math and Reading Language Arts (RLA) tests taken by public-school students in grades 3 through 8 between 2022 and 2025. See the <a href=\"/help-faq/#how-measures-computed\" target=\"_blank\">FAQ</a> for more detail.",
  "HELP_COH_CONCEPT": "How do trends in test scores show changes in a community's educational opportunities?",
  "HELP_COH_CONCEPT_A": "Average student test scores are influenced by home environments, early childhood experiences, community resources, and schools. The trend (or change) in average student test scores from one year to the next indicates whether educational opportunities are improving or declining in a community. Where the trend is positive, students’ opportunities to learn are improving. Opportunities may improve over time because of changes in school quality or because of changes in family resources, home environments, early childhood experiences, and/or community resources.",
  "HELP_CURRENT": "Current View",
  "HELP_DATA_OVERVIEW": "The test scores represented here were collected in grades 3-8 from 2008-09 through 2017-18 at public elementary and middle schools in the U.S.",
  "HELP_DESC_AVG": "the range of average test scores",
  "HELP_DESC_AVG_DETAILS": "of grade levels above and below the national average",
  "HELP_DESC_COH": "Trend in Test Scores",
  "HELP_DESC_COH_DETAILS": "representing how much average test scores have improved or declined over time",
  "HELP_DESC_GRD": "the range of learning rates",
  "HELP_DESC_GRD_DETAILS": "representing how much learning rates have improved or declined over time",
  "HELP_FLAGGED": "My school or district is flagged as missing data in recent years (2016–2019). What does this mean and why is recent data for my school or district missing?",
  "HELP_FLAGGED_A": "If a school or district is flagged (see image below) as missing more than 50% of test score data for recent years (2016-2019), this means that estimates are based on older data (before 2016). Why? Less data were reported between 2016-2019 due to state test opt out which began in the Spring of 2015. Reasons for opt out vary and the number of parents opting students out of taking state assessments also varies year-to-year. To learn more about opt out policies for students in your area, we recommend that you visit your local school, district, or state website.",
  "HELP_FRL": "How is the free/reduced-price lunch percentage calculated and what does it mean?",
  "HELP_FRL_A": "The free/reduced-price lunch percentage measures the proportion of students in the school who are eligible for free or reduced-price lunches through the National School Lunch Program. Students are eligible for free or reduced-price lunches if their family income is below 185% of the poverty threshold. A school with a free lunch rate of 0% has no poor or near-poor students; the higher the free lunch rate, the greater the number of poor students. The lower the free/reduced-price lunch percentage, the more affluent the school.",
  "HELP_GRD": "How are learning rates calculated?",
  "HELP_GRD_A": "The learning rate is based on changes in average test scores from each year and grade to the next year and grade (e.g. changes from 2015 3rd-grade scores to 2016 4th-grade scores). The learning rates are calculated using standardized math and Reading Language Arts (RLA) tests taken by public school students in grades 3 through 8 between 2022 and 2025. See the <a href=\"/help-faq/#how-measures-computed\" target=\"_blank\">FAQ</a> for more detail.",
  "HELP_GRD_CONCEPT": "Why do average learning rates largely reflect a school’s effectiveness?",
  "HELP_GRD_CONCEPT_A": "Learning rates measure how much students’ scores improve each year while they are in school. This is a better way to assess what children learn in schools than average test scores, which are heavily influenced by factors outside of school. To understand the distinction, think of a hospital: We wouldn’t assess a hospital based on the health of its patients; rather, we’d judge it on how much the health of patients improves as a result of their time in the hospital. Similarly, we shouldn’t evaluate a school based on the average scores of its students, but rather by how much their scores improve while in school.",
  "HELP_HOW_Q1": "What are the different ways of exploring the data?",
  "HELP_HOW_Q1_A": "The Educational Opportunity Explorer offers three different ways of looking at educational opportunity in the U.S.: a map, a chart, and a “split screen\" view of both. Use the <strong>Map | Chart | Map + Chart</strong> buttons in the header to select one of these views.",
  "HELP_HOW_Q10": "How do I export a report about my selected location?",
  "HELP_HOW_Q10_A": "<p>Click on any location in the map or charts, and a <strong>Location Panel</strong> will appear containing data about that place. Scroll to the bottom of this panel and click <strong>Export a Report</strong>, then <strong>Download Report</strong>.</p>\n<p>This will generate a PDF report for any location, which contains charts, figures, and other information about the currently-selected district or school.</p>",
  "HELP_HOW_Q11": "Where can I get more help & info about educational opportunity?",
  "HELP_HOW_Q11_A": "To learn more about the concepts presented here and how to use this Explorer tool, please see our <a href=\"/help-faq/\" target=\"_blank\">FAQ</a>. To learn more about educational opportunity in America, please see our <a href=\"/discoveries/\" target=\"_blank\">Discoveries</a> articles, which explore and visualize different facets of educational opportunity. You can also see a list of <a href=\"/news/\" target=\"_blank\">news</a> articles about this data, view our <a href=\"/research/\" target=\"_blank\">research papers</a>, and learn about our <a href=\"/methods/\" target=\"_blank\">methods</a> for compiling and validating the data.",
  "HELP_HOW_Q12": "How can I download the data?",
  "HELP_HOW_Q12_A": "Please see our <a href=\"/get-the-data/\" target=\"_blank\">Get the Data</a> page to gain access to the full dataset.",
  "HELP_HOW_Q13": "How can I filter the data?",
  "HELP_HOW_Q13_A": "<p>In the Data Options column displayed on the left, click Data Filters. Using the controls in this panel, you can filter what data is displayed on the map and charts by size, school type, and more.</p>\n<p>When multiple selections are made, the filters work together to narrow what is displayed. For example, if you limit results to schools within Arizona, and check the boxes for only charter schools and urban schools, only urban charter schools in Arizona will be shown.</p>\n<p>To return to the default view, click the “Reset data filters” button.</p>",
  "HELP_HOW_Q14": "How can I view data for Bureau of Indian Education (BIE) schools?",
  "HELP_HOW_Q14_A": "<p>Schools overseen by the Bureau of Indian Education are included in our data. To filter the display to show only these schools, navigate to the Data Options column on the left side of the Explorer and select “schools” as the Region type. Then choose Data Filters and scroll down to “School Type.”</p>\n<p>Uncheck the boxes to remove all other school types, so that only “Bureau of Indian Education” remains checked. The map and charts will then display only BIE schools.</p>\n<p>To return to the default view, click the “Reset data filters” button.</p>",
  "HELP_HOW_Q2": "What data can I choose from?",
  "HELP_HOW_Q2_A": "<p>At the top of this Explorer, you can select from <strong>3 Key Measures</strong> of educational opportunity to display in the map and chart:</p>\n<ul>\n  <li> - Average test scores, which reflect educational opportunities in and out of school</li>\n  <li> - Learning rates, which reflect school effectiveness</li>\n  <li> - Trends in test scores, which reflect changes in educational opportunity</li>\n</ul>\n<p>Just below these buttons, you can use the left-side Data Options panel to filter by demographic (e.g. “all students\" or “female students”) or gap between demographics (e.g. “male-female gap”), and the type of places (states, school districts, or schools) you'd like to display. In the Chart view, you can choose to view the entire country, or individual states.</p>",
  "HELP_HOW_Q3": "What do the colors in the map and charts mean?",
  "HELP_HOW_Q3_A": "<p>Light gray represents the national average, or “no change” (for trends in test scores).</p>\n<p>The deeper the green, the farther above the national average‚or, for trends in test scores, the greater the improvement in scores over time.</p>\n<p>The deeper the blue, the farther below the national average‚or for trends in test scores, the greater the decline in scores over time.</p>\n<p><i>Colorblind users: We have made efforts to ensure accessibility for the most common forms of colorblindness. For less common forms (such as tritanopia), colors may be less distinguishable; however, the data are still accessible in the map legend, charts, and other displays.</i></p>",
  "HELP_HOW_Q4": "What do the colors in the map and charts mean?",
  "HELP_HOW_Q4_A": "You can view data for states, school districts, and public schools. To change between location types, use the <strong>Region</strong> menu in the Data Options panel at left.",
  "HELP_HOW_Q5": "How can I find a location and view its data?",
  "HELP_HOW_Q5_A": "<p>You can navigate to your desired location via the navigation controls in the map. Or type a location name into the search bar in the header.</p>\n<p>Hovering (or on a touch device, tapping) on a location in the map or chart will show an overview of that location’s data. Clicking or tapping on the location will open a <strong>Location Panel</strong> that shows a full view of all available data, as well as options for viewing other selected locations. You can also export a <strong>PDF report</strong> from this panel.</p>\n<p>Clicking or tapping on locations will also add them to the Locations menu within the left-side Data Options panel. (You can add an unlimited number of locations.) Click or tap on any location’s tab to highlight it in the map or chart, and the Locations menu.</p>",
  "HELP_HOW_Q6": "How many locations can I select at once?",
  "HELP_HOW_Q6_A": "Starting with version 1.1.0 of the Explorer, you can select an unlimited number of locations at once. Selected locations will be stored in the Locations menu within the left-side Data Options menu.",
  "HELP_HOW_Q7": "How do I see all the data for a location at once?",
  "HELP_HOW_Q7_A": "Clicking or tapping on any location will open a <strong>Location Panel</strong> that offers a full view of the data.",
  "HELP_HOW_Q8": "How do I view data on comparable locations?",
  "HELP_HOW_Q8_A": "<p>In two ways. First, you can select multiple locations by clicking on a place in the map or on the chart, or by searching for a location in the search bar.</p> \n<p>Then, in Locations menu within the left-side Data Options panel, click the “Compare Locations” button to view all their data together in a pop-up window. In the pop-up window, you can also select one location and click the “Load Similar” button to display additional locations that are similar to the selected place.</p>\n<p>You also have the option to export a CSV file with data on an unlimited number of selected locations.</p>",
  "HELP_HOW_Q9": "How can I see data on gaps between demographic groups?",
  "HELP_HOW_Q9_A": "<p>For each Key Measure (such as average test scores), we offer data on the gaps between certain demographic groups, such as White / Black, Male / Female, and Non-Poor / Poor.</p>\n<p>You can view these gaps in the map and chart by selecting groups for comparison in the <strong>Subgroup/Gap</strong> menu in the left-side Data Options panel.</p>\n<p>In Map View, the size of the gap is shown as colors on the map.</p>\n<p>In Chart View, the demographic groups are charted on the horizontal and vertical axes, and the distance from the diagonal line in the chart shows the size of the gap.</p>\n<p>While in Chart View, you can also select <strong>Show Gap vs. Other Metrics</strong> to view a second chart. Here, the size of the gap is plotted on the vertical axis. The gap between groups on another measure (such as socioeconomic status) is shown on the horizontal axis.</p>\n<p>You can also view all demographic scores and gaps for a particular place in the <strong>Location Panel</strong> that opens when clicking / tapping on a location.</p>",
  "HELP_HOW_TO": "How to use the explorer",
  "HELP_LEGEND_HIGH_AVG": "higher",
  "HELP_LEGEND_HIGH_COH": "higher",
  "HELP_LEGEND_HIGH_IMP": "higher",
  "HELP_LEGEND_HIGH_GRD": "higher",
  "HELP_LEGEND_LOW_AVG": "lower",
  "HELP_LEGEND_LOW_COH": "lower",
  "HELP_LEGEND_LOW_IMP": "lower",
  "HELP_LEGEND_LOW_GRD": "lower",
  "HELP_LEGEND_VAL_AVG_GAP_HIGH": "Difference of $[value] grade levels in favor of $[students].",
  "HELP_LEGEND_VAL_AVG_GAP_LOW": "Difference of $[value] grade levels in favor of $[students].",
  "HELP_LEGEND_VAL_AVG_GAP_MID": "No difference",
  "HELP_LEGEND_VAL_AVG_HIGH": "$[students] score $[value] grade levels above average",
  "HELP_LEGEND_VAL_AVG_LOW": "$[students] score $[value] grade levels below average",
  "HELP_LEGEND_VAL_AVG_MID": "national average",
  "HELP_LEGEND_VAL_COH_GAP_HIGH": "Difference of $[value] in trend of test scores in favor of $[students].",
  "HELP_LEGEND_VAL_COH_GAP_LOW": "Difference of $[value] in trend of test scores in favor of $[students].",
  "HELP_LEGEND_VAL_COH_GAP_MID": "No difference",
  "HELP_LEGEND_VAL_COH_HIGH": "$[students]' average test scores improve $[value] grade levels per year",
  "HELP_LEGEND_VAL_COH_LOW": "$[students]' average test scores decline $[value] grade levels per year",
  "HELP_LEGEND_VAL_COH_MID": "no change",

  "HELP_LEGEND_VAL_IMP_GAP_HIGH": "Difference of $[value] grade levels in favor of $[students].",
  "HELP_LEGEND_VAL_IMP_GAP_LOW": "Difference of $[value] grade levels in favor of $[students].",
  "HELP_LEGEND_VAL_IMP_GAP_MID": "No difference",
  "HELP_LEGEND_VAL_IMP_HIGH": "$[students]' learning rates improve $[value] grade levels per year",
  "HELP_LEGEND_VAL_IMP_LOW": "$[students]' learning rates decline $[value] grade levels per year",
  "HELP_LEGEND_VAL_IMP_MID": "no change",

  "HELP_LEGEND_VAL_GRD_GAP_HIGH": "Difference of $[value] in learning rates in favor of $[students].",
  "HELP_LEGEND_VAL_GRD_GAP_LOW": "Difference of $[value] in learning rates in favor of $[students].",
  "HELP_LEGEND_VAL_GRD_GAP_MID": "No difference",
  "HELP_LEGEND_VAL_GRD_HIGH": "$[students] learn $[value] more per grade than average",
  "HELP_LEGEND_VAL_GRD_LOW": "$[students] learn $[value] less per grade than average",
  "HELP_LEGEND_VAL_GRD_MID": "national average",
  "HELP_MAP": "What does the map show?",
  "HELP_MAP_AVG_OVERVIEW": "This map can be customized to show the average test scores, learning rates, or trends in test scores for students in U.S. schools, districts, or states. The test scores represented here were collected in grades 3-8 from 2008-09 through 2018-19 at public elementary and middle schools in the U.S. For more information on how we calculate educational opportunity metrics, see the <a href=\"/help-faq\" target=\"_blank\">FAQ</a>.",
  "HELP_MAP_COH_OVERVIEW": "Average student test scores are influenced by children’s home environments, early childhood experiences, community resources, and schools. The trend (or change) in average student test scores from one year to the next indicates whether educational opportunities are improving or declining in a community.",
  "HELP_MAP_DESC": "This map of $[region] in $[state] shows $[metric] for $[demographic], on a scale $[metricDescription].",
  "HELP_MAP_DESC_GAP": "This map of $[region] in $[state] shows the $[gap] in $[metric].",
  "HELP_MAP_GRD_OVERVIEW": "Learning rates measure how much student scores improve each year while they are in school. This is a better way to assess what children learn in schools than average test scores, which are heavily influenced by factors outside of school.",
  "HELP_MIN": "What is the gap in percent minority students in schools and how is it calculated?",
  "HELP_MIN_A": "The gap in percent minority students in schools (shown in the secondary gap charts) is a measure of school segregation, see the <a href=\"/help-faq/\" target=\"_blank\">FAQ</a> for more detail about how it is calculated. When there is no segregation—when white and black students attend the same schools, or when white and black students’ schools have equal proportions of minority students—the black-white gap in percent minority students is 0. A positive black-white gap in percent minority students means that black students’ schools have higher shares of minority students than white students’ schools, on average. A negative black-white gap in percent minority students means that white students’ schools have higher shares of minority students than black students’ schools, on average.",
  "HELP_OTHER": "More Help",
  "HELP_PANEL_HOW_TAB": "How to explore",
  "HELP_PANEL_TITLE": "Help",
  "HELP_PANEL_WHAT_TAB": "What am I seeing",
  "HELP_SEG": "What is the gap in school poverty and how is it calculated?",
  "HELP_SEG_A": "The gap in school poverty is a measure of school segregation. We use the proportion of students defined as “economically disadvantaged” in a school as a measure of school poverty. The black-white gap in school poverty, for example, measures the difference between the poverty rate of the average black student’s school and the poverty rate of the average white student’s school. When there is no segregation—when white and black students attend the same schools, or when white and black students’ schools have equal poverty rates—the black-white school poverty gap is 0. A positive black-white school poverty gap means that black students’ schools have higher poverty rates than white students’ schools, on average. A negative black-white school poverty gap means that white students’ schools have higher poverty rates than black students’ schools, on average.",
  "HELP_SES": "What is socioeconomic status and how is it calculated?",
  "HELP_SES_A": "The gap in percent minority students in schools (shown in the secondary gap charts) is a measure of school segregation, see the <a href=\"/help-faq/\" target=\"_blank\">FAQ</a> for more detail about how it is calculated. When there is no segregation—when white and black students attend the same schools, or when white and black students’ schools have equal proportions of minority students—the black-white gap in percent minority students is 0. A positive black-white gap in percent minority students means that black students’ schools have higher shares of minority students than white students’ schools, on average. A negative black-white gap in percent minority students means that white students’ schools have higher shares of minority students than black students’ schools, on average.",
  "HINT_AVG": "An indicator of educational opportunity, this shows how students score, in grade levels, relative to the national average for students in grades 3 - 8.",
  "HINT_COH": "An indicator of educational opportunity changes over time, this shows an average of how students' test scores change in grade levels per year, for students in grades 3 - 8.",
  "HINT_DEMOGRAPHIC": "Represents the subgroup to show educational opportunity for.  Choose from subgroups categorized by race, gender, or socioeconomic status, or gaps that show differences between subgroups.",
  "HINT_GAP_AVG": "",
  "HINT_GAP_COH": "",
  "HINT_GAP_IMP": "",
  "HINT_GAP_DEMOGRAPHIC": "Represents the gap in opportunity between $[dem1] and $[dem2] students for the selected educational opportunity metric. Choose from a variety of gaps between subgroups or focus in on a specific subgroup by race, gender, or socioeconomic status.",
  "HINT_GAPGRD": "",
  "HINT_GRD": "An indicator of school effectiveness, this shows an average of how much students' test scores improve per year, relative to the national average, as they progress through grades 3 - 8.",
  "HINT_IMP": "An indicator of school effectiveness, this shows how student test scores are growing across grades, compared to the national average.",
  "HINT_MIN": "We define minority students as the sum of the proportion Black, Hispanic, and Native American students at a school. The gap in percent minority students in schools is a measure of school segregation.  When there is no segregation, or when students' schools have equal proportions of minority students, the gap in percent minority students is 0. A gap in percent minority students means that one subgroup's schools have higher shares of minority students than the other, on average.",
  "HINT_REGION": "Represents the level of educational opportunity data to display.  Choose from states, school districts, or individual school levels.",
  "HINT_SEG": "The gap in school poverty is a measure of school segregation. We use the proportion of students defined as \"economically disadvantaged\" in a school as a measure of school poverty. The gap in school poverty measures the difference of average poverty rates between two subgroups. When there is no segregation or when schools have equal poverty rates the school poverty gap is 0. A gap in school poverty means that one subgroups' schools have higher poverty rates than the other on average.",
  "HINT_SES": "Socioeconomic status is a broad measure of the economic and social resources available in a community. It is based on information about the income, educational attainment, employment, and structure of all families living in the community served by a school district. This information is combined into a single composite rating for each community. A rating of 0 represents the national average of socioeconomic status; higher ratings represent more affluent communities.",
  "HP_CHART": "chart",
  "HP_MAP": "map",
  "HP_SES": "socioeconomic status",
  "HP_SPLIT": "map and chart",
  "LABEL_A": "Asian",
  "LABEL_A_AVG": "Asian students' average test scores",
  "LABEL_A_COH": "Asian students' trend in test scores",
  "LABEL_A_GRD": "Asian students' learning rates",
  "LABEL_A_IMP": "Asian students' trend in learning rates",
  "LABEL_A_SES": "Asian families' socioeconomic status",
  "LABEL_ALL": "all",
  "LABEL_ALL_AVG": "Average Test Scores",
  "LABEL_ALL_COH": "Trend in Test Scores",
  "LABEL_ALL_GRD": "Learning Rates",
  "LABEL_ALL_IMP": "Trend in Learning Rates",
  "LABEL_ALL_FRL": "Free/Reduced Lunch",
  "LABEL_ALL_SES": "Average families' socioeconomic status",
  "LABEL_AVG": "average test scores",
  "LABEL_B": "Black",
  "LABEL_B_AVG": "Black students' average test scores",
  "LABEL_B_COH": "Black students' trend in test scores",
  "LABEL_B_GRD": "Black students' learning rates",
  "LABEL_B_IMP": "Black students' trend in learning rates",
  "LABEL_B_SES": "Black families' socioeconomic status",
  "LABEL_COH": "trend in test scores",
  "LABEL_IMP": "trend in learning rates",
  "LABEL_COMPARE_SUBGROUP": "Comparison subgroup / gap:",
  "LABEL_CONCEPT_AVG": "educational opportunity",
  "LABEL_CONCEPT_COH": "educational opportunity change",
  "LABEL_CONCEPT_GRD": "school effectiveness",
  "LABEL_CONCEPT_IMP": "educational improvement",
  "LABEL_COUNTIES": "counties",
  "LABEL_CHART": "chart",
  "LABEL_DEMOGRAPHIC": "subgroup / gap",
  "LABEL_DISTRICTS": "school districts",
  "LABEL_EXPORT_CSV": "Export CSV",
  "LABEL_F": "Female",
  "LABEL_F_AVG": "Female students' average test scores",
  "LABEL_F_COH": "Female students' trend in test scores",
  "LABEL_F_GRD": "Female students' learning rates",
  "LABEL_F_IMP": "Female students' trend in learning rates",
  "LABEL_F_SES": "$[region] socioeconomic status",
  "LABEL_FRL": "Free/Reduced Lunch",
  "LABEL_GAP": "$[demographic1] and $[demographic2]",
  "LABEL_GAP_NP": "Non-Poor - Poor Gap in",
  "LABEL_GAP_PN": "Non-Poor - Poor Gap in",
  "LABEL_GAP_WA": "White - Asian Gap in",
  "LABEL_GAP_WB": "White - Black Gap in",
  "LABEL_GAP_WH": "White - Hispanic Gap in",
  "LABEL_GAP_WI": "White - Native American Gap in",
  "LABEL_GAP_FLIP_WB": "Black - White Gap in",
  "LABEL_GAP_FLIP_WH": "Hispanic - White Gap in",
  "LABEL_GAP_FLIP_WI": "Native American - White Gap in",
  "LABEL_GAP_FLIP_WA": "Asian - White Gap in",
  "LABEL_GAP_FLIP_NP": "Poor - Non-poor Gap in",
  "LABEL_GAP_FLIP_PN": "Poor - Non-poor Gap in",
  "LABEL_GRD": "learning rates",
  "LABEL_H": "Hispanic",
  "LABEL_H_AVG": "Hispanic students' average test scores",
  "LABEL_H_COH": "Hispanic students' trend in test scores",
  "LABEL_H_GRD": "Hispanic students' learning rates",
  "LABEL_H_IMP": "Hispanic students' trend in learning rates",
  "LABEL_H_SES": "Hispanic families' socioeconomic status",
  "LABEL_I": "Native American",
  "LABEL_I_AVG": "Native American students' average test scores",
  "LABEL_I_COH": "Native American students' trend in test scores",
  "LABEL_I_GRD": "Native American students' learning rates",
  "LABEL_I_IMP": "Native American students' trend in learning rates",
  "LABEL_I_SES": "Native American families' socioeconomic status",
  "LABEL_ID": "ID",
  "LABEL_LOADING": "Loading...",
  "LABEL_LOCATION_STUDENTS_ALL": "Overall Average",
  "LABEL_M": "Male",
  "LABEL_M_AVG": "Male students' average test scores",
  "LABEL_M_COH": "Male students' trend in test scores",
  "LABEL_M_GRD": "Male students' learning rates",
  "LABEL_M_IMP": "Male students' trend in learning rates",
  "LABEL_M_SES": "$[region] socioeconomic status",
  "LABEL_MAP": "map",
  "LABEL_METRIC": "educational opportunity metric",
  "LABEL_MF": "male - female gap",
  "LABEL_MF_AVG": "Male - Female Gap in Test Scores",
  "LABEL_MF_COH": "Male - Female Gap in Test Score Trends",
  "LABEL_MF_GRD": "Male - Female Gap in Learning Rates",
  "LABEL_MF_IMP": "Male - Female Gap in Learning Rate Trends",
  "LABEL_MIN": "Percent Minority Students in Schools",
  "LABEL_N": "Non-poor",
  "LABEL_NAME": "Name",
  "LABEL_NO_NAME": "Unknown",
  "LABEL_NP": "Non-poor",
  "LABEL_NP_AVG": "Non-poor students' average test scores",
  "LABEL_NP_COH": "Non-poor students' trend in test scores",
  "LABEL_NP_GRD": "Non-poor students' learning rates",
  "LABEL_NP_IMP": "Non-poor students' trend in learning rates",
  "LABEL_NP_SEG": "poor - non-poor gap in school poverty",
  "LABEL_NP_SES": "$[region] socioeconomic status",
  "LABEL_P": "Poor",
  "LABEL_P_AVG": "Poor students' average test scores",
  "LABEL_P_COH": "Poor students' trend in test scores",
  "LABEL_P_GRD": "Poor students' learning rates",
  "LABEL_P_IMP": "Poor students' trend in learning rates",
  "LABEL_P_SES": "$[region] socioeconomic status",
  "LABEL_PN": "non-poor - poor gap",
  "LABEL_PN_AVG": "Non-Poor - Poor Gap in Test Scores",
  "LABEL_PN_COH": "Non-Poor - Poor Gap in Test Score Trends",
  "LABEL_PN_GRD": "Non-Poor - Poor Gap in Learning Rates",
  "LABEL_PN_IMP": "Non-Poor - Poor Gap in Learning Rate Trends",
  "LABEL_PREVIEW_CHART": "Relationship with $[secondary]",
  "LABEL_PREVIEW_CHART_GAP": "$[opportunityType] ($[dem1] vs. $[dem2])",
  "LABEL_PREVIEW_CHANGE_VIEW": "Switch to a different view to interact with the chart",
  "LABEL_REFLECTS_AVG": "reflects educational opportunity",
  "LABEL_REFLECTS_COH": "reflects educational opportunity change",
  "LABEL_REFLECTS_GRD": "reflects school effectiveness",
  "LABEL_REFLECTS_IMP": "reflects school improvement",
  "LABEL_REGION": "region",
  "LABEL_SCHOOLS": "schools",
  "LABEL_SEG": "School Poverty",
  "LABEL_SES": "Socioeconomic Status",
  "LABEL_SES_NO_REGION": "socioeconomic status",
  "LABEL_SES_REGION": "$[region] socioeconomic status",
  "LABEL_SHORT_BW": "White - Black",
  "LABEL_SHORT_FM": "male - female",
  "LABEL_SHORT_HW": "White - Hispanic",
  "LABEL_SHORT_IW": "White - Native American",
  "LABEL_SHORT_MF": "male - female",
  "LABEL_SHORT_PN": "Non-Poor - Poor",
  "LABEL_SHORT_WB": "White - Black",
  "LABEL_SHORT_WH": "White - Hispanic",
  "LABEL_SHORT_WI": "White - Native American",
  "LABEL_SHORT_WA": "White - Asian",
  "LABEL_SINGULAR_COUNTIES": "county",
  "LABEL_SINGULAR_DISTRICTS": "school district",
  "LABEL_SINGULAR_SCHOOLS": "school",
  "LABEL_SINGULAR_STATES": "state",
  "LABEL_SIZE": "Show largest",
  "LABEL_STATES": "states",
  "LABEL_STUDENTS_A": "Asian students",
  "LABEL_STUDENTS_ALL": "all students",
  "LABEL_STUDENTS_B": "Black students",
  "LABEL_STUDENTS_F": "Female students",
  "LABEL_STUDENTS_H": "Hispanic students",
  "LABEL_STUDENTS_I": "Native American students",
  "LABEL_STUDENTS_M": "Male students",
  "LABEL_STUDENTS_MF": "Male - Female",
  "LABEL_STUDENTS_N": "Non-poor students",
  "LABEL_STUDENTS_NP": "Non-poor students",
  "LABEL_STUDENTS_P": "Poor students",
  "LABEL_STUDENTS_PN": "Non-poor - Poor",
  "LABEL_STUDENTS_W": "White students",
  "LABEL_STUDENTS_WB": "White - Black",
  "LABEL_STUDENTS_WH": "White - Hispanic",
  "LABEL_STUDENTS_WI": "White - Native American",
  "LABEL_STUDENTS_WA": "White - Asian",
  
  "LABEL_STUDENTS_LOWER_A": "Asian students",
  "LABEL_STUDENTS_LOWER_ALL": "all students",
  "LABEL_STUDENTS_LOWER_B": "Black students",
  "LABEL_STUDENTS_LOWER_F": "female students",
  "LABEL_STUDENTS_LOWER_H": "Hispanic students",
  "LABEL_STUDENTS_LOWER_I": "Native American students",
  "LABEL_STUDENTS_LOWER_M": "male students",
  "LABEL_STUDENTS_LOWER_MF": "male - female",
  "LABEL_STUDENTS_LOWER_N": "non-poor students",
  "LABEL_STUDENTS_LOWER_NP": "non-poor students",
  "LABEL_STUDENTS_LOWER_P": "poor students",
  "LABEL_STUDENTS_LOWER_PN": "non-poor - Poor",
  "LABEL_STUDENTS_LOWER_W": "White students",
  "LABEL_STUDENTS_LOWER_WB": "White - Black",
  "LABEL_STUDENTS_LOWER_WH": "White - Hispanic",
  "LABEL_STUDENTS_LOWER_WI": "White - Native American",
  "LABEL_STUDENTS_LOWER_WA": "White - Asian",

  "LABEL_SZ": "Show largest",
  "LABEL_W": "White",
  "LABEL_WA": "White - Asian gap",
  "LABEL_W_AVG": "White students' average test scores",
  "LABEL_W_COH": "White students' trend in test scores",
  "LABEL_W_GRD": "White students' learning rates",
  "LABEL_W_IMP": "White students' trend in learning rates",
  "LABEL_W_SES": "White families' socioeconomic status",
  "LABEL_WB": "White - Black gap",
  "LABEL_WB_AVG": "White - Black Gap in Test Scores",
  "LABEL_WB_COH": "White - Black Gap in Test Score Trends",
  "LABEL_WB_GRD": "White - Black Gap in Learning Rates",
  "LABEL_WB_IMP": "White - Black Gap in Learning Rate Trends",
  "LABEL_WB_MIN": "Black - White gap in percent minority students in schools",
  "LABEL_WB_SEG": "Black - White gap in school poverty",
  "LABEL_WB_SES": "White - Black gap in socioeconomic status",
  "LABEL_WH": "White - Hispanic gap",
  "LABEL_WH_AVG": "White - Hispanic Gap in Test Scores",
  "LABEL_WH_COH": "White - Hispanic Gap in Test Score Trends",
  "LABEL_WH_IMP": "White - Hispanic Gap in Learning Rate Trends",
  "LABEL_WH_GRD": "White - Hispanic Gap in Learning Rates",
  "LABEL_WH_MIN": "Hispanic - White Gap in Percent Minority Students in Schools",
  "LABEL_WH_SEG": "Hispanic - White gap in school poverty",
  "LABEL_WH_SES": "White - Hispanic gap in socioeconomic status",
  "LABEL_WI": "White - Native American gap",
  "LABEL_WI_AVG": "White - Native American Gap in Test Scores",
  "LABEL_WI_COH": "White - Native American Gap in Test Score Trends",
  "LABEL_WI_GRD": "White - Native American Gap in Learning Rates",
  "LABEL_WI_IMP": "White - Native American Gap in Learning Rate Trends",
  "LABEL_WI_MIN": "Native American - White Gap in Percent Minority Students in Schools",
  "LABEL_WI_SEG": "Native American - White gap in school poverty",
  "LABEL_WI_SES": "White - Native American gap in socioeconomic status",
  "LABEL_WA_AVG": "White - Asian Gap in Test Scores",
  "LABEL_WA_COH": "White - Asian Gap in Test Score Trends",
  "LABEL_WA_GRD": "White - Asian Gap in Learning Rates",
  "LABEL_WA_IMP": "White - Asian Gap in Learning Rate Trends",
  "LABEL_WA_MIN": "Asian - White Gap in Percent Minority Students in Schools",
  "LABEL_WA_SEG": "Asian - White gap in school poverty",
  "LABEL_WA_SES": "White - Asian gap in socioeconomic status",
  "LEGEND_CHART_BUTTON": "Show Interactive Chart",
  "LEGEND_CHART_INTERACTIVE": "Go to the expanded chart to explore interactively:",
  "LEGEND_DESC_AVG": "in grade levels, relative to the U.S. average",
  "LEGEND_DESC_COH": "in grade levels, how much test scores change each year",
  "LEGEND_DESC_IMP": "in grade levels, how much learning rates change each year",
  "LEGEND_DESC_GAP_AVG": "below zero = higher $[1] scores, above zero = higher $[0] scores",
  "LEGEND_DESC_GAP_COH": "below zero = gap is decreasing, above zero = gap is increasing",
  "LEGEND_DESC_GAP_GRD": "below zero = $[1] learns more, above zero = $[0] learns more",
  "LEGEND_DESC_GRD": "amount learned per grade, relative to U.S. average",
  "LEGEND_HIGH": "higher",
  "LEGEND_HIGH_AVG": "above grade level",
  "LEGEND_HIGH_AVG_MF": "",
  "LEGEND_HIGH_AVG_PN": "",
  "LEGEND_HIGH_AVG_WB": "",
  "LEGEND_HIGH_AVG_WH": "",
  "LEGEND_HIGH_COH": "scores improving",
  "LEGEND_HIGH_COH_MF": "",
  "LEGEND_HIGH_COH_PN": "",
  "LEGEND_HIGH_COH_WB": "",
  "LEGEND_HIGH_COH_WH": "",
  "LEGEND_HIGH_FRL": "less poverty",
  "LEGEND_HIGH_GRD": "learns more",
  "LEGEND_HIGH_GRD_MF": "",
  "LEGEND_HIGH_GRD_PN": "",
  "LEGEND_HIGH_GRD_WB": "",
  "LEGEND_HIGH_GRD_WH": "",
  "LEGEND_HIGH_MIN_WB": "More Racial School Segregation",
  "LEGEND_HIGH_MIN_WH": "More Racial School Segregation",
  "LEGEND_HIGH_SEG": "More Racial-Economic School Segregation",
  "LEGEND_HIGH_SEG_WB": "More Racial-Economic School Segregation",
  "LEGEND_HIGH_SEG_WH": "More Racial-Economic School Segregation",
  "LEGEND_HIGH_SES": "richer",
  "LEGEND_HIGH_SES_WB": "",
  "LEGEND_HIGH_SES_WH": "",
  "LEGEND_LOW": "lower",
  "LEGEND_LOW_AVG": "below grade level",
  "LEGEND_LOW_AVG_MF": "",
  "LEGEND_LOW_AVG_PN": "",
  "LEGEND_LOW_AVG_WB": "",
  "LEGEND_LOW_AVG_WH": "",
  "LEGEND_LOW_COH": "scores dropping",
  "LEGEND_LOW_COH_MF": "",
  "LEGEND_LOW_COH_PN": "",
  "LEGEND_LOW_COH_WB": "",
  "LEGEND_LOW_COH_WH": "",
  "LEGEND_LOW_FRL": "more poverty",
  "LEGEND_LOW_GRD": "learns less",
  "LEGEND_LOW_GRD_MF": "",
  "LEGEND_LOW_GRD_PN": "",
  "LEGEND_LOW_GRD_WB": "",
  "LEGEND_LOW_GRD_WH": "",
  "LEGEND_LOW_MIN_WB": "",
  "LEGEND_LOW_MIN_WH": "",
  "LEGEND_LOW_SEG": "",
  "LEGEND_LOW_SEG_WB": "",
  "LEGEND_LOW_SEG_WH": "",
  "LEGEND_LOW_SES": "poorer",
  "LEGEND_LOW_SES_WB": "",
  "LEGEND_LOW_SES_WH": "",
  "LEGEND_MAP_AVG": "Average Test Scores for $[0]",
  "LEGEND_MAP_COH": "Trend in Test Scores for $[0]",
  "LEGEND_MAP_IMP": "Trend in Learning Rates for $[0]",
  "LEGEND_MAP_GAP_AVG": "$[0] in Average Test Scores",
  "LEGEND_MAP_GAP_COH": "$[0] in Test Score Trends",
  "LEGEND_MAP_GAP_IMP": "$[0] in Trend in Learning Rates",
  "LEGEND_MAP_GAP_GRD": "$[0] in Learning Rates",
  "LEGEND_MAP_GRD": "Learning Rates for $[0]",
  "LEGEND_MID_AVG": "U.S. average",
  "LEGEND_MID_COH": "no change",
  "LEGEND_MID_IMP": "no change",
  "LEGEND_MID_GAP_AVG": "0",
  "LEGEND_MID_GAP_COH": "0",
  "LEGEND_MID_GAP_IMP": "0",
  "LEGEND_MID_GAP_GRD": "0",
  "LEGEND_MID_GRD": "U.S. average",
  "LEGEND_SHORT_HIGH_AVG": "higher",
  "LEGEND_SHORT_HIGH_COH": "higher",
  "LEGEND_SHORT_HIGH_IMP": "higher",
  "LEGEND_SHORT_HIGH_FRL": "low poverty",
  "LEGEND_SHORT_HIGH_GRD": "higher",
  "LEGEND_SHORT_HIGH_SES": "richer",
  "LEGEND_SHORT_LOW_AVG": "lower",
  "LEGEND_SHORT_LOW_COH": "lower",
  "LEGEND_SHORT_LOW_IMP": "lower",
  "LEGEND_SHORT_LOW_FRL": "high poverty",
  "LEGEND_SHORT_LOW_GRD": "lower",
  "LEGEND_SHORT_LOW_SES": "poorer",
  "LINE_EQUAL_OPPORTUNITY": "no gap ($[demographic1] = $[demographic2])",
  "LINK_COPY_LABEL": "copy link",
  "LINK_DIALOG_TITLE": "Share a Link",
  "LINK_INPUT_LABEL": "Current View URL",
  "LINK_INSTRUCTIONS": "Copy the link below to share the current view of the explorer.",
  "LOAD_SIMILAR_BUTTON": "Load Similar",
  "LOAD_SIMILAR_DISABLED": "Loading similar regions is optimized for districts and schools.",
  "LOAD_SIMILAR_HINT": "Load the 5 most similar places to $[location], based on demographics and socioeconomic conditions.",
  "LOCATION_COMPARE_BUTTON": "Compare Locations",
  "LOCATION_REPORT_BUTTON": "Download Report",
  "LOCATION_REPORT_BUTTON_DISABLED_SCHOOL": "Reports are only available for school districts and states",
  "LOCATION_REPORT_BUTTON_DISABLED_DATA": "There is no report available for this $[region]",
  "LOCATION_SUBHEADING_GAPS": "Differences in $[metric]",
  "LOCATION_SUBHEADING_OVERALL": "Opportunity Metrics For All Students",
  "LOCATION_SUBHEADING_SUBGROUP": "$[metric] By Subgroup",
  "LOCATION_SUBHEADING_SUMMARY": "Educational Opportunity Overview",
  "LOCATION_SUBHEADING_SUMMARY_OVERALL": "Overall:",
  "LOCATION_SUBHEADING_SUMMARY_COMPARED": "Compared to places with similar socioeconomic status:",
  "LOCATION_SUBHEADING_TIMESERIES_AVG": "$[start]-$[end] Trend in Average Test Scores for $[group]",
  "LOCATIONS_ACTIVE_NONE": "You have not selected any schools, districts, or states. Use the search bar above or select place in the map or chart view.",
  "LOCATIONS_NONE": "No places selected.",
  "LOCATIONS_SEARCH": "Find a place",
  "LOCATIONS_SELECTED": "Selected Places",
  "LOGO_ALT_TEXT": "Educational Opportunity Project",
  "MENU_HOME": "Home",
  "MENU_DISCOVERIES": "Discoveries",
  "MENU_RESEARCH": "Research",
  "MENU_NEWS": "In the News",
  "MENU_OPPORTUNITY": "Educational Opportunity Project",
  "MENU_OPPORTUNITY_SUB": "(2009-2019)",
  "MENU_TRENDS": "Educational Opportunity Trends Project",
  "MENU_TRENDS_SUB": "(2022-2025)",
  "MENU_EARLY_CHILDHOOD": "Early Childhood Educational Opportunity Project",
  "MENU_EARLY_CHILDHOOD_SUB": "",
  "MENU_SEGREGATION": "Segregation Tracking Project",
  "MENU_VERTICAL_EXPLORER": "Explorer",
  "MENU_VERTICAL_ABOUT": "About",
  "MENU_VERTICAL_METHODS": "Methods",
  "MENU_VERTICAL_FAQ": "FAQ",
  "MENU_VERTICAL_DATA": "Get the Data",
  "MENU_FACEBOOK": "Educational Opportunity Project on Facebook",
  "MENU_TWITTER": "Educational Opportunity Project on Twitter",
  "MENU_YOUTUBE": "Educational Opportunity Project on YouTube",
  "MENU_LINKEDIN": "Educational Opportunity Project on LinkedIn",
  "MOBILE_SUBLINE": "for $[demographic] in $[place] $[region]",
  "NO_DATA": "Unavailable",
  "NO_DATA_SHORT": "--",
  "OP_TITLE_AVG": "Achievement Differences Between $[dem1] and $[dem2]",
  "OP_TITLE_COH": "Change in Achievement Differences Between $[dem1] and $[dem2]",
  "OP_TITLE_GRD": "Growth Differences Between $[dem1] and $[dem2]",
  "PANEL_DESCRIPTION_GAPS": "Gaps show the difference in educational opportunity between two subgroups by subtracting one subgroup’s values from the other. The further a gap value is from 0, the larger the imbalance between the two subgroups.",
  "PANEL_DESCRIPTION_LOCATIONS": "Locations that you have previously selected show up here. Select states, districts, and schools using the map, chart, or search bar.",
  "PANEL_DESCRIPTION_METRICS": "The achievement metrics are based on math and reading test scores for students in grades 3-8 for the years 2022-2025. Average test scores are relative to the 2019 national average.",
  "PANEL_DESCRIPTION_SUBGROUPS": "Subgroups and gaps are not available when viewing school level data.  Switch to state or districts to view subgroup data.",
  "PANEL_FILTER_MANY": "$[num] filters applied",
  "PANEL_FILTER_NONE": "No filters applied",
  "PANEL_FILTER_SINGLE": "One filter applied",
  "PANEL_LOCATION_MANY": "$[num] locations selected",
  "PANEL_LOCATION_NONE": "No locations selected",
  "PANEL_LOCATION_SINGLE": "One location selected",
  "PANEL_TITLE_DEMOGRAPHIC": "Subgroup / Gap",
  "PANEL_TITLE_FILTER": "Data Filters",
  "PANEL_TITLE_LARGEST": "Filter by Size",
  "PANEL_TITLE_LOCATION": "Locations",
  "PANEL_TITLE_METRIC": "Educational Opportunity Metric",
  "PANEL_TITLE_REGION": "Region",
  "PANEL_TITLE_STATE": "Filter by State",
  "PANEL_HINT_METRIC_TITLE": "NEW METRIC ADDED",
  "PANEL_HINT_METRIC_BODY": "Trend in Learning Rates. Click here to view.",
  "SCATTERPLOT_DESCRIPTION": "Circles represent $[region], sized relative to the number of $[demographic] students.",
  "SCATTERPLOT_FILTERED": "The largest $[highlighted] $[region] are visible.",
  "SCATTERPLOT_DESCRIPTION_GAP": "Circles represent $[region], sized relative to the number of $[dem1] and $[dem2] students. Any $[region] above the horizontal and/or to the right of the vertical \"no gap\" lines have a gap favoring $[dem1] students in $[metric] and/or socioeconomic status, respectively. The largest 5,000 districts are visible.",
  "SCATTERPLOT_DESCRIPTION_VS": "Circles represent $[region], sized relative to the number of $[dem1] and $[dem2] students. Dotted line indicates no gap between $[dem1] and $[dem2] students. Any $[region] below the dotted line indicate a gap favoring $[dem1] students.",
  "SCATTERPLOT_TITLE": "Average $[demographic] Students' $[metric] vs. $[secondary]",
  "SCATTERPLOT_TITLE_AVG": "Average $[demographic] Students' Test Scores vs. $[secondary]",
  "SCATTERPLOT_TITLE_GAP": "Gap in $[metric] vs. $[secondary] Between $[dem1] and $[dem2] Students",
  "SCATTERPLOT_TITLE_VS": "Gap in $[metric] Between $[dem1] and $[dem2] Students",
  "TIMESERIES_AXIS_AVG": "Average Test Scores",
  "SEARCH_PLACEHOLDER": "Find a city, district, or school",
  "SHARE_TWITTER": "Explore educational opportunity in your community and around the country",
  "SP_SUBTITLE": "$[place] $[region], $[demographic], grades 3 - 8 from 2022 - 2025, sized by number of students",
  "SP_TITLE": "$[metric] vs. $[secondary]",
  "SP_TITLE_GAP": "Difference in $[metric] vs. $[secondary]",
  "SP_TITLE_VS": "Differences in $[metric]",
  "SUMMARY_AVG_HIGH": "Test scores are <strong>higher</strong> than U.S. average",
  "SUMMARY_AVG_LOW": "Test scores are <strong>lower</strong> than U.S. average",
  "SUMMARY_AVG_MID": "Test scores are <strong>roughly the same</strong> as the U.S. average",
  "SUMMARY_AVGFRL_HIGH": "Test scores are <strong>higher</strong> than $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_AVGFRL_LOW": "Test scores are <strong>lower</strong> than $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_AVGFRL_MID": "Test scores are <strong>equal</strong> to $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_AVGSES_HIGH": "Test scores are <strong>higher</strong>",
  "SUMMARY_AVGSES_LOW": "Test scores are <strong>lower</strong>",
  "SUMMARY_AVGSES_MID": "Test scores are <strong>roughly equal</strong>",
  "SUMMARY_COH_HIGH": "Test scores are <strong>improving</strong> over time",
  "SUMMARY_COH_LOW": "Test scores are <strong>declining</strong> over time",
  "SUMMARY_COH_MID": "Test scores are relatively stable over time",
  "SUMMARY_COHFRL_HIGH": "Test scores are <strong>improving</strong> more than $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_COHFRL_LOW": "Test scores are <strong>declining faster</strong> than $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_COHFRL_MID": "Test scores are changing at a similar rate to $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_COHSES_HIGH": "Test scores are <strong>improving</strong> faster",
  "SUMMARY_COHSES_LOW": "Test scores are <strong>declining</strong> faster",
  "SUMMARY_COHSES_MID": "Test scores are staying roughly the same",
  "SUMMARY_IMP_HIGH": "Learning rates are <strong>improving</strong> over time",
  "SUMMARY_IMP_LOW": "Learning rates are <strong>declining</strong> over time",
  "SUMMARY_IMP_MID": "Learning rates are relatively stable over time",
  "SUMMARY_IMPFRL_HIGH": "Learning rates are <strong>improving</strong> more than $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_IMPFRL_LOW": "Learning rates are <strong>declining faster</strong> than $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_IMPFRL_MID": "Learning rates are changing at a similar rate to $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_IMPSES_HIGH": "Learning rates are <strong>improving</strong> faster",
  "SUMMARY_IMPSES_LOW": "Learning rates are <strong>declining</strong> faster",
  "SUMMARY_IMPSES_MID": "Learning rates are staying roughly the same",
  "SUMMARY_GRD_HIGH": "Learning rates are <strong>faster</strong> than U.S. average",
  "SUMMARY_GRD_LOW": "Learning rates are <strong>slower</strong> than U.S. average",
  "SUMMARY_GRD_MID": "Learning rates are <strong>roughly the same</strong> as the U.S. average",
  "SUMMARY_GRDFRL_HIGH": "Learning rates are <strong>higher</strong> than $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_GRDFRL_LOW": "Learning rates are <strong>lower</strong> than $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_GRDFRL_MID": "Learning rates are <strong>equal</strong> to $[region] with similar free/reduced-price lunch percentage",
  "SUMMARY_GRDSES_HIGH": "Learning rates are <strong>higher</strong>",
  "SUMMARY_GRDSES_LOW": "Learning rates are <strong>lower</strong>",
  "SUMMARY_GRDSES_MID": "Learning rates are <strong>roughly equal</strong>",
  "SUMMARY_SES_HIGH": "Socioeconomic status is above average",
  "SUMMARY_SES_LOW": "Socioeconomic status is below national average",
  "SUMMARY_SES_MID": "Socioeconomic status about average",
  "SUMMARY_SES_ULTRA_HIGH": "Socioeconomic status very far above national average",
  "SUMMARY_SES_ULTRA_LOW": "Socioeconomic status very far below national average",
  "SUMMARY_SES_VERY_HIGH": "Socioeconomic status far above national average",
  "SUMMARY_SES_VERY_LOW": "Socioeconomic status far below national average",
  "TOOLTIP_CONTEXT_A": "for Asian students",
  "TOOLTIP_CONTEXT_ALL": "for all students",
  "TOOLTIP_CONTEXT_B": "for Black students",
  "TOOLTIP_CONTEXT_F": "for female students",
  "TOOLTIP_CONTEXT_H": "for Hispanic students",
  "TOOLTIP_CONTEXT_I": "for Native American students",
  "TOOLTIP_CONTEXT_M": "for male students",
  "TOOLTIP_CONTEXT_MF": "gap between male and female",
  "TOOLTIP_CONTEXT_NP": "for non-poor students",
  "TOOLTIP_CONTEXT_P": "for poor students",
  "TOOLTIP_CONTEXT_PN": "gap between Non-poor and Poor",
  "TOOLTIP_CONTEXT_W": "for White students",
  "TOOLTIP_CONTEXT_WB": "gap between White and Black",
  "TOOLTIP_CONTEXT_WH": "gap between White and Hispanic",
  "TOOLTIP_CONTEXT_WI": "gap between White and Native America",
  "TOOLTIP_CONTEXT_WA": "gap between White and Asian",
  "TOOLTIP_DESC_AVG_GAP": "grade level difference",
  "TOOLTIP_DESC_AVG_HIGH": "grades above U.S. average",
  "TOOLTIP_DESC_AVG_LOW": "grades below U.S. average",
  "TOOLTIP_DESC_AVG_MID": "equal to U.S. average",

  "TOOLTIP_DESC_COH_GAP": "grade level difference",
  "TOOLTIP_DESC_COH_HIGH": "increase in scores per year",
  "TOOLTIP_DESC_COH_LOW": "decrease in scores per year",
  "TOOLTIP_DESC_COH_MID": "equal to U.S. average",

  "TOOLTIP_DESC_IMP_GAP": "grade level difference",
  "TOOLTIP_DESC_IMP_HIGH": "improvement in learning rates per year",
  "TOOLTIP_DESC_IMP_LOW": "decline in learning rates per year",
  "TOOLTIP_DESC_IMP_MID": "equal to U.S. average",
  
  "TOOLTIP_DESC_FRL_HIGH": "free/reduced price lunch",
  "TOOLTIP_DESC_GRD_GAP": "difference",
  "TOOLTIP_DESC_GRD_HIGH": "more learned each year",
  "TOOLTIP_DESC_GRD_LOW": "less learned each year",
  "TOOLTIP_DESC_GRD_MID": "equal to U.S. average",
  "TOOLTIP_DESC_SES_GAP": "difference",
  "TOOLTIP_DESC_SES_HIGH": "above U.S. average",
  "TOOLTIP_DESC_SES_LOW": "below national average",
  "TOOLTIP_DESC_SES_MID": "about average",
  "TOOLTIP_DESC_SES_ULTRA_HIGH": "very far above national average",
  "TOOLTIP_DESC_SES_ULTRA_LOW": "very far below U.S. average",
  "TOOLTIP_DESC_SES_VERY_HIGH": "far above national average",
  "TOOLTIP_DESC_SES_VERY_LOW": "far below national average",
  "TOOLTIP_DESC_SEG_GAP": "difference",
  "TOOLTIP_DESC_MIN_GAP": "difference",
  "TOOLTIP_HINT": "Click on a $[region] for more data.",
  "TOOLTIP_HINT_CHART": "click to toggle the chart preview",
  "TOOLTIP_HINT_DEMOGRAPHIC": "click to change subgroup or gap",
  "TOOLTIP_HINT_FILTER": "click to change filters",
  "TOOLTIP_HINT_HIDE": "hide side panel",
  "TOOLTIP_HINT_LOCATION": "click to view selected locations",
  "TOOLTIP_HINT_METRIC": "click to change metric",
  "TOOLTIP_HINT_REGION": "click to change region",
  "TOOLTIP_HINT_SHOW": "show data options",
  "TOOLTIP_HINT_REGION_FILTER": "These filters are only available in $[regions] view.",
  "TOOLTIP_HINT_BIE": "Bureau of Indian Education",
  "TOOLTIP_SUMMARY": "Click on a location for more.",
  "TOOLTIP_SWITCH_AVG": "Switch to Average Test Scores",
  "TOOLTIP_SWITCH_COH": "Switch to Trends in Test Scores",
  "TOOLTIP_SWITCH_IMP": "Switch to Trend in Learning Rates",
  "TOOLTIP_SWITCH_GRD": "Switch to Learning Rates",
  "TOOLTIP_SWITCH_GAP_AVG": "Switch to gaps in Average Test Scores",
  "TOOLTIP_SWITCH_GAP_COH": "Switch to gaps in Test Score Trends",
  "TOOLTIP_SWITCH_GAP_GRD": "Switch to gaps in Learning Rates",
  "TOOLTIP_SWITCH_GAP_IMP": "Switch to gaps in Learning Rate Trends",
  "UI_BRANDING_SR": "Brought to you by Stanford University",
  "UI_CHART_BUTTON": "Chart",
  "UI_CHART_BUTTON_SR": "Go to chart view",
  "UI_CHART_SR": "Scatterplot with dots representing $[region] in the United States. $[region] are positioned vertically on the Y axis based on $[yVar] and horizontally on the X axis based on $[xVar].",
  "UI_LEGEND_BAR_SR": "A legend bar for $[title] showing $[lowValue] on the low end, $[midValue] in the middle, and $[highValue] on the high end.",
  "UI_MAP_BUTTON": "Map",
  "UI_MAP_BUTTON_SR": "Go to map view",
  "UI_MAP_SR": "Map of $[region] in the United States, with colors showing $[metric] for $[demographic].",
  "UI_REPORT_LOADING": "Generating PDF report. Please be patient‚ this may take up to 30 seconds...",
  "UI_SPLIT_BUTTON": "Chart + map",
  "UI_SPLIT_BUTTON_SR": "Go to chart and map split view",
  "VALUE_AVG_GAP": "$[demographic1] and $[demographic2] students’ average scores differ by $[value] grade levels.",
  "VALUE_AVG_HIGH": "scores are <strong>$[value] grade levels above</strong> U.S. average",
  "VALUE_AVG_LOW": "scores are <strong>$[value] grade levels below</strong> U.S. average",
  "VALUE_AVG_MID": "test scores are at the national average",
  "VALUE_COH_GAP": "$[demographic1] and $[demographic2] students’ test score trends differ by $[value] grade levels per year.",
  "VALUE_COH_HIGH": "test scores <strong>increased an average of $[value] grade levels</strong> each year",
  "VALUE_COH_LOW": "test scores <strong>decreased an average of $[value] grade levels</strong> each year",
  "VALUE_COH_MID": "test scores did not change from 2022-2025",

  "VALUE_IMP_GAP": "$[demographic1] and $[demographic2] students’ learning rates differ by $[value] grade levels per year.",
  "VALUE_IMP_HIGH": "learning rates <strong>improved an average of $[value]</strong> grade levels each year",
  "VALUE_IMP_LOW": "learning rates <strong>declined an average of $[value]</strong> grade levels each year",
  "VALUE_IMP_MID": "learning rates did not change from 2022-2025",

  "VALUE_FRL": "<strong>$[value] of students</strong> qualify for free or reduced lunch program.",
  "VALUE_GRD_GAP": "$[demographic1] and $[demographic2] students’ learning rates differ by $[value] per year.",
  "VALUE_GRD_HIGH": "students learn <strong>$[value] more each grade</strong> than the U.S. average",
  "VALUE_GRD_LOW": "students learn <strong>$[value] less each grade</strong> than the U.S. average",
  "VALUE_GRD_MID": "students learn the same each grade as the U.S. average",
  "VALUE_MIN_GAP": "The percent of minority students in $[demographic2] students’ schools is $[value] $[highLow] than in $[demographic1] students’ schools.",
  "VALUE_SEG": "<strong>$[value] school poverty</strong>",
  "VALUE_SEG_GAP": "The poverty rate in $[demographic2] students’ schools is $[value] $[highLow] than in $[demographic1] students’ schools.",
  "VALUE_SES_GAP": "$[demographic1] students’ average socioeconomic status is $[difference] $[demographic2] students’.",
  "VALUE_SES_HIGH": "Socioeconomic status is <strong>above national average</strong>.",
  "VALUE_SES_LOW": "Socioeconomic status is <strong>below national average</strong>.",
  "VALUE_SES_MID": "Socioeconomic status is <strong>about average</strong>.",
  "VALUE_SES_ULTRA_HIGH": "Socioeconomic status is <strong>very far above national average</strong>.",
  "VALUE_SES_ULTRA_LOW": "Socioeconomic status is <strong>very far below national average</strong>.",
  "VALUE_SES_VERY_HIGH": "Socioeconomic status is <strong>far above national average</strong>.",
  "VALUE_SES_VERY_LOW": "Socioeconomic status is <strong>far below national average</strong>.",
  "HINT_FRL": "Free/reduced-price lunch percentage measures the proportion of students in the school who are eligible for free or reduced-price lunches through the National School Lunch Program. Students are eligible for free or reduced-price lunches if their family income is below 185% of the poverty threshold. A school with a free lunch rate of 0% has no poor or near-poor students; the higher the free lunch rate, the greater the number of poor students. The lower the free/reduced-price lunch percentage, the more affluent the school."
} 

export default LANG